<div class="progress-container">
	<div class="img-loading glass bg-black/40">
		{{msg()}}
		<progress class="progress progress-white glass"></progress>
	</div>
</div>